import React from "react";
import { useTranslation } from "react-i18next";
import { CardListSummary, CategoryBadgeName, CardProductTabName } from "../../constants/Card";
import { getVersionUrl } from "common/cacheOverwrite";

type CardListSummaryItemProps = {
  cardProductCode: string;
  onClick: (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => void;
};

/**
 * 카드 리스트(APPL01) 카테고리 요약 카드 (Premier·Dream·Welcome·Quick)
 * 로그인 · 비로그인 카드 리스트 공통. 상품 영역 전체가 터치 영역
 */
const CardListSummaryItem: React.FC<CardListSummaryItemProps> = ({ cardProductCode, onClick }) => {
  /** 다국어처리 */
  const { t } = useTranslation();

  const summary = CardListSummary[Number(cardProductCode)];

  return (
    <li className={`card cardSummary ${summary.iconColor}`} onClick={onClick} data-code={cardProductCode}>
      <p className="summaryTit">{`${CardProductTabName[Number(cardProductCode)]} ATM+`}</p>
      <div className="summaryBody">
        <div className="summaryThumb">
          <img src={getVersionUrl(localStorage.getItem(`${cardProductCode}_B`) as string)} alt="" />
        </div>
        <div className="summaryInfo">
          <ul className="summaryList">
            {summary.items.map((item) => (
              <li key={item.subCode}>
                <span className={`summaryBadge ${item.category}`}>{CategoryBadgeName[item.category]}</span>
                <span className="summaryTxt">
                  {item.prefix
                    ? <>{item.prefix}<b>{t(`APPL01.${summary.listCode}.${item.subCode}`, item.defaults)}</b></>
                    : t(`APPL01.${summary.listCode}.${item.subCode}`, item.defaults)}
                </span>
              </li>
            ))}
          </ul>
          {/* 연간 혜택 요약 */}
          <p className="summaryBenefit">
            <b>{summary.benefitAmount}</b> {t(summary.benefitKey, summary.benefitDefaults)}
          </p>
          <button type="button" className="summaryBtn">
            {t(summary.buttonKey, summary.buttonDefaults)}
          </button>
        </div>
      </div>
    </li>
  );
};

export default CardListSummaryItem;
